import { FETCH_META_DEVICE } from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_META_DEVICE:
      return { ...state, device: action.payload };
    default:
      return state;
  }
};
